import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import notificationService from '../../../services/notificationService';

const CompatibilityAlert = ({ isVisible, onDismiss, onViewDetails }) => {
  if (!isVisible) return null;

  // Trigger intelligent notification when alert becomes visible
  React.useEffect(() => {
    if (isVisible) {
      // Gather context for intelligent notification
      const moodData = {
        mood: 'adventurous',
        energy: 8,
        emotionalState: 'excited',
      };

      const partnerHistory = {
        recentMoods: ['playful', 'adventurous', 'intimate'],
      };

      const relationshipContext = {
        compatibilityScore: 85,
        preferredTimes: ['evenings', 'weekends'],
        lastEncounter: '3 days ago',
      };

      // Send intelligent notification
      notificationService?.notifyIntelligentMoodChange(
        moodData,
        partnerHistory,
        relationshipContext
      );
    }
  }, [isVisible]);

  return (
    <div className="p-4 rounded-md bg-accent/10 border border-accent/30">
      <div className="flex items-start space-x-3">
        <div className="flex items-center justify-center w-10 h-10 rounded-md bg-accent/20 flex-shrink-0">
          <Icon name="Sparkles" size={24} color="var(--color-accent)" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h4 className="text-base font-heading font-semibold text-foreground">
              High Compatibility Match!
            </h4>
            <button
              onClick={onDismiss}
              className="text-muted-foreground hover:text-foreground transition-therapeutic"
            >
              <Icon name="X" size={18} color="currentColor" />
            </button>
          </div>
          <p className="text-sm text-foreground mb-3">
            Your partner's current mood aligns well with yours. This could be a great time to connect.
          </p>
          <div className="flex flex-col sm:flex-row gap-2">
            <button
              onClick={onViewDetails}
              className="flex items-center justify-center space-x-2 px-4 py-2 rounded-md bg-accent text-accent-foreground hover:bg-accent/90 transition-therapeutic text-sm font-medium"
            >
              <Icon name="Calendar" size={16} color="currentColor" />
              <span>Schedule Encounter</span>
            </button>
            <button
              onClick={onViewDetails}
              className="flex items-center justify-center space-x-2 px-4 py-2 rounded-md border border-accent text-accent hover:bg-accent/10 transition-therapeutic text-sm font-medium"
            >
              <Icon name="MessageCircle" size={16} color="currentColor" />
              <span>Send Message</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompatibilityAlert;